/* global $ */
'use strict';

function errorMessages() {
	var Handlebars = require('handlebars');

	var errors = {errors: $.t('errors', {returnObjectTrees: true})};
	var $errorTemplate = $('#error-messages-template');
	var $body = $('body');
	var template = Handlebars.compile($errorTemplate.html());

	$body.append(template(errors));
}

module.exports = errorMessages;
